import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: flex-end;
`
